import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../Buttons/StatusBadgeWithDropdown';

const data = [
    {
        plant: 'PLANT',
        sloc: 'SLOC',
        buildingNo: 'BUILDING NO (Opt)',
        asile: 'ASILE',
        rack: 'RACK #',
        rackHeight: 'RACK HEIGHT,Ft',
        level: 'LEVEL #',
        bin: 'BIN #',
        binSizeL: 'BIN SIZE (L)',
        binSizeW: 'BIN SIZE (W)',
        binSizeH: 'BIN SIZE (H)',
        volume: 'VOLUME',
        palletSize: 'PALLET SIZE (Opt)',
        capacity: 'CAPACITY (LBS/KG)',
        storageType: 'STORAGE TYPE',
        zoneName: 'ZONE NAME',
        zoneNumber: 'ZONE NUMBER',
    },
    {
        plant: 'PLANT',
        sloc: 'SLOC',
        buildingNo: 'BUILDING NO (Opt)',
        asile: 'ASILE',
        rack: 'RACK #',
        rackHeight: 'RACK HEIGHT,Ft',
        level: 'LEVEL #',
        bin: 'BIN #',
        binSizeL: 'BIN SIZE (L)',
        binSizeW: 'BIN SIZE (W)',
        binSizeH: 'BIN SIZE (H)',
        volume: 'VOLUME',
        palletSize: 'PALLET SIZE (Opt)',
        capacity: 'CAPACITY (LBS/KG)',
        storageType: 'STORAGE TYPE',
        zoneName: 'ZONE NAME',
        zoneNumber: 'ZONE NUMBER',
    },
];

const columns = [
    { id: 'plant', label: 'PLANT', align: 'left', minWidth: '150px' },
    { id: 'sloc', label: 'SLOC', align: 'left', minWidth: '150px' },
    { id: 'buildingNo', label: 'BUILDING NO (Opt)', align: 'left', minWidth: '180px' },
    { id: 'asile', label: 'ASILE', align: 'left', minWidth: '150px' },
    { id: 'rack', label: 'RACK #', align: 'left', minWidth: '150px' },
    { id: 'rackHeight', label: 'RACK HEIGHT,Ft', align: 'left', minWidth: '150px' },
    { id: 'level', label: 'LEVEL #', align: 'left', minWidth: '150px', },
    { id: 'bin', label: 'BIN #', align: 'left', minWidth: '150px', },
    { id: 'binSizeL', label: 'BIN SIZE (L)', align: 'left', minWidth: '150px', },
    { id: 'binSizeW', label: 'BIN SIZE (W)', align: 'left', minWidth: '150px', },
    { id: 'binSizeH', label: 'BIN SIZE (H)', align: 'left', minWidth: '150px', },
    { id: 'volume', label: 'VOLUME', align: 'left', minWidth: '150px', },
    { id: 'palletSize', label: 'PALLET SIZE (Opt)', align: 'left', minWidth: '180px', },
    { id: 'capacity', label: 'CAPACITY (LBS/KG)', align: 'left', minWidth: '180px', },
    { id: 'storageType', label: 'STORAGE TYPE', align: 'left', minWidth: '150px', },
    { id: 'zoneName', label: 'ZONE NAME', align: 'left', minWidth: '150px', },
    { id: 'zoneNumber', label: 'ZONE NUMBER', align: 'left', minWidth: '150px', },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const LayoutMapTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                    {column.label}
                                    {column.sortable !== false && (
                                        <IconButton
                                            size="small"
                                            onClick={(event) => handleRequestSort(event, column.id)}
                                        >
                                            <img src={SortIcon} alt="Sort" />
                                        </IconButton>
                                    )}
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((customer) => (
                        <TableRow key={customer.id}>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                    {column.id === 'Status' ? (
                                        // <span
                                        // className={`status-badge-for-enabling ${customer.status === 'Enable' ? 'complete-status' : 'cancel-status'}`}
                                        // >
                                        //     {customer.status}&nbsp;&nbsp;&nbsp;&nbsp;
                                        //     <span className="dropdown-arrow">
                                        //         <img src={SortIcon} alt="dropdown icon" />
                                        //     </span>
                                        // </span>
                                        <StatusBadgeWithDropdown customer={customer} activeText="Enable"
                                            inactiveText="Disable" />
                                    ) : column.id === 'action' ? (
                                        <SbActionDropdownButton
                                            options={[{ type: 'Edit' }, { type: 'View' }, { type: 'Download' }, { type: 'Delete' }]}
                                            openAddModal={props.handleOpenModal}
                                            addBulkModel={props.handleOpenViewModal}
                                        />
                                    ) : (
                                        customer[column.id]
                                    )}
                                </TableCell>

                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                    Ascending to Descending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                    Descending to Ascending
                </MenuItem>
            </Menu>
        </TableContainer>
    );
};

export default LayoutMapTable;
